import { Autocomplete, AutocompleteProps, SxProps, TextField, Theme, Typography } from '@mui/material'
import * as React from 'react'
import { useState } from 'react'

type AutoCompleteEstadosProps = {
    onChange: (estado: string | null) => void,
    value: string | null,
    label?: string
    size?: AutocompleteProps<any, any, any, any>['size']
    sx?: SxProps<Theme>
}

export default function AutoCompleteEstados({ onChange, value, size, sx, label = "Seleccionar estado" }: AutoCompleteEstadosProps) {
    const [open, setOpen] = useState(false)
    const [estadosList] = useState([
        { title: 'Pendiente', inputValue: '0' },
        { title: 'En proceso', inputValue: '1' },
        { title: 'Informada', inputValue: '2' },
    ])

    return (
        <>
            <Autocomplete
                sx={sx}
                size={size}
                fullWidth
                value={estadosList.find((estado) => estado.inputValue === value) || null}
                open={open}
                onOpen={() => {
                    setOpen(true)
                }}
                onClose={() => {
                    setOpen(false)
                }}
                isOptionEqualToValue={(option, value) => option.inputValue === value?.inputValue}
                getOptionLabel={(option) => option.title}
                options={estadosList}
                onChange={(event, newValue) => {
                    onChange(newValue ? newValue.inputValue : null) // -1 si no hay selección
                }}
                loadingText="Cargando..."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        size={size}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Typography noWrap>
                            {option.title}
                        </Typography>
                    </li>
                )}
            />
        </>
    )
}
